import type { LuxPlusOffSessionPaymentCard } from 'api/payment'
import {
  hasMatchingLuxPlusCheckoutCardBackupCandidate,
  luxPlusOffSessionCardToLuxPlusCheckoutCardBackupCandidate,
  stripePaymentCardToLuxPlusCheckoutCardBackupCandidate,
} from 'checkout/lib/luxPlusCheckoutCardBackup'
import getLuxPlusCardExpiresBeforeRenewal from 'luxPlus/lib/getLuxPlusCardExpiresBeforeRenewal'

/**
 * Saved cards the member can promote to their LP+ renewal card from the invalid card modal.
 * Drops any card that is likely the same as an LP+ card (by payment method id, then fingerprint and expiry,
 * since LP+ cards live on the connect account) and any card that expires before renewal.
 * A reissued card (same fingerprint, new expiry) is kept.
 */
function getLuxPlusInvalidCardReplacementCards(
  savedCards: Array<App.StripePaymentCardV2>,
  luxPlusCards: Array<LuxPlusOffSessionPaymentCard>,
  renewalDate?: string,
): Array<App.StripePaymentCardV2> {
  const luxPlusCandidates = luxPlusCards.map(luxPlusOffSessionCardToLuxPlusCheckoutCardBackupCandidate)

  return savedCards.filter(savedCard => {
    const savedCandidate = stripePaymentCardToLuxPlusCheckoutCardBackupCandidate(savedCard)
    const matchesLuxPlusCard = luxPlusCandidates.some(luxPlusCandidate => hasMatchingLuxPlusCheckoutCardBackupCandidate(savedCandidate, luxPlusCandidate))
    return !matchesLuxPlusCard && !getLuxPlusCardExpiresBeforeRenewal(savedCard, renewalDate)
  })
}

export default getLuxPlusInvalidCardReplacementCards
